import { QSearch } from "./QSearch";
import { QPersonalizedEvents } from "./QPersonalizedEvents";
import { QGetEvents } from "./QGetEvents";
import { QGetLeagues } from "./QGetLeagues";
export const QueryBuilder = {
    search: QSearch,
    personalizedEvents: QPersonalizedEvents,
    getEvents: QGetEvents,
    getLeagues: QGetLeagues
};
//# sourceMappingURL=index.js.map